import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { NavbarComponent } from './components/navbar/navbar.component';  
import { RouterModule } from '@angular/router'; 
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [NavbarComponent, RouterModule ],
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'csi-admin-ui';

  constructor(private meta: Meta, private router: Router) {
    this.meta.addTag({name: 'google-signin-client_id', content: environment.cliendId});
    
  const tree = this.router.parseUrl(this.router.url);
  const returnUrl = tree.queryParams['returnUrl'] || '/';

  }
}
